import { createContext, useReducer } from "react";
import secureLocalStorage from "react-secure-storage";

export const NoteState = createContext();

const parseJSON = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const accessToken = localStorage.getItem("access-token");
const userId = secureLocalStorage.getItem("userId");
const branchId = secureLocalStorage.getItem("branchId");
const role = secureLocalStorage.getItem("role");
const initialState = {
  accessToken: parseJSON(accessToken),
  userId: parseJSON(userId),
  branchId: parseJSON(branchId),
  role: parseJSON(role),
};

function reducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("access-token", JSON.stringify(action.accessToken));
      secureLocalStorage.setItem("branchId", JSON.stringify(action.branchId));
      secureLocalStorage.setItem("userId", JSON.stringify(action.userId));
      secureLocalStorage.setItem("role", JSON.stringify(action.role));
      return {
        ...state,
        accessToken: action.accessToken,
        userId: action.userId,
        branchId: action.branchId,
        role: action.role,
      };

    case "LOGOUT":
      localStorage.removeItem("access-token");
      secureLocalStorage.removeItem("branchId");
      secureLocalStorage.removeItem("userId");
      secureLocalStorage.removeItem("role");
      return {
        ...state,
        accessToken: null,
        userId: null,
        branchId: null,
        role: null,
      };
    default:
      return state;
  }
}
export function UserProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };

  return (
    <NoteState.Provider value={value}>{props.children}</NoteState.Provider>
  );
}
